export const ALLOWED_NETWORKS_REDE_MOVEL = ["claro sa", "claro s.a.", "claro s.a"]